








































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';

import { lccaStore } from '@/store/store';
import ProbabilisticInputs from '@/modules/lcca/views/components/ProbablisticInputs.vue';
import { UnitSystem } from '@/interfaces/units';
import { BaseProbVariables } from '@/modules/lcca/interfaces/probabilistic';
import { createLccaValidations } from '@/modules/lcca/lib/validations';
import { getProbabilisticByName, getUserProbInputs } from '@/modules/lcca/lib/util';


@Component({
  components: {
    PxNumberInput,
    ProbabilisticInputs,
    // InputPageWrapper,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class LccaTrafficData extends Vue {
  @Prop() readonly pxLccaId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return lccaStore.currentScenario;
  }

  get scenarioImperial() {
    return lccaStore.currentImperial;
  }

  validations() {
    return createLccaValidations(this.scenarioImperial);
  }

  get unitSystemIsImperial() {
    return this.scenario.displayUnits === UnitSystem.Imperial;
  }


  get userProbInputs() {
    return getUserProbInputs(this.scenarioImperial);
  }

  get trafficProbabilisticInputs() {
    return getProbabilisticByName(this.scenario.probabilistic, BaseProbVariables.annualGrowthTraffic);
  }

  // @Watch('trafficProbabilisticInputs', {immediate: true, deep: true})
  // setTrafficProb(values: IDistribution, oldValues: IDistribution | null) {
  //   // this.scenario.annualGrowthTraffic_max = values.max;
  //   // this.scenario.annualGrowthTraffic_mean = values.mean;
  //   // this.scenario.annualGrowthTraffic_min = values.min;
  //   // this.scenario.annualGrowthTraffic_mode = values.mode;
  //   // this.scenario.annualGrowthTraffic_std = values.std;
  //   // this.scenario.annualGrowthTraffic_prob = values.prob;
  //   this.scenario.probabilistic = this.scenario.probabilistic.filter(P => P.name !== BaseProbVariables.annualGrowthTraffic);
  //   this.scenario.probabilistic.push(values)
  // }

  sync() {
    lccaStore.setCurrentScenario(this.scenario);
  }

  save() {
    this.sync();
    lccaStore.saveCurrentScenario();
  }
}

